// extracted by mini-css-extract-plugin
export default {"divMain":"AcceptLabel_divMain__URaNB"};